module.exports = __webpack_public_path__ + "img/labels.5ba37df6.svg";